import { httpClient } from "@/app/old/desktop/shared/services/";
class API {
  constructor() {
    this.baseURL = null;
  }
  async get_users(req = {}) {
    return httpClient({
      url: `organization/filter-users/${req.query ? `?${req.query}` : ""}`,
      baseURL: this.baseURL.replace("dc", req.dc),
      headers: req.headers,
      data: req.body,
      method: "POST",
    }).then(res => res.data);
  }
}
export const drsService = new API();
// export { projectService };
